import React from 'react';
import { TemplateProps } from '../types';

export const DialogBody = ({ children }: TemplateProps): JSX.Element => (
  <div className='syte-dialog-body'>{children}</div>
);
